export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";

export type ErrorState = Record<string, string>;

export type ErrorPayload = {
  errorMessage: string;
};
